import { captureException } from '@sentry/react';

import { type RelatedNewsItem } from 'hb-react/shared/apps/News/types';
import { pickPath } from 'hb-react/shared/utils/api/pickPath';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export interface GetRelatedNewsRequestProps {
  newsId: string;
  signal?: AbortSignal;
  topicId?: number | null;
  userId?: number | null;
  whiteLabelTopic?: boolean;
}

export const getRelatedNewsRequest = ({
  userId,
  whiteLabelTopic,
  topicId,
  newsId,
  signal,
}: GetRelatedNewsRequestProps) => {
  const path = pickPath({
    userId,
    topicId,
    isWLTopic: whiteLabelTopic,
    paths: {
      networkFO: null, // We do not load related items in the FO
      topicFO: null, // We do not load related items in the FO
      networkPO: Routes.private_publicoffice_news_related_items_path,
      topicPO: Routes.private_publicoffice_topics_news_related_items_path,
    },
  })(newsId);

  if (!path) {
    captureException(
      new Error(
        'Trying to fetch related news in the FO, but no endpoint exist for this use case.',
      ),
    );
    return Promise.resolve({ data: { data: [] } });
  }

  return axios.get<{ data: Array<RelatedNewsItem> }>(path, {
    signal,
  });
};
